import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Breadcrumb from "../breadcrumb/Breadcrumb";
import Loader from "../loading/Loader";
import { useGarmentMeasurementServiceContext } from "../../contexts/GarmentMeasurementServiceContext";
import ImageUpload from "./garment-measurement-service/garment-measurement-service-steps/ImageUpload";
import MeasurementResult from "./garment-measurement-service/garment-measurement-service-steps/MeasurementResult";
import GarmentMeasurementServiceStepIndicator from "./garment-measurement-service/GarmentMeasurementServiceStepIndicator";
import Processing from "./garment-measurement-service/garment-measurement-service-steps/Processing";
import { FREE_TRIAL } from "../../utilities/defaults/free-trial/plans";
import { BetaBadge } from "../common/BetaBadge";
import GarmentMeasurementTourModal from "./garment-measurement-service/GarmentMeasurementTourModal";

const GarmentMeasurementService: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { currentStep, showTourGuideModal, closeTourGuideModal } = useGarmentMeasurementServiceContext();
  const [service, setService] = useState<(typeof FREE_TRIAL)[number] | null>(null);

  useEffect(() => {
    const foundService = FREE_TRIAL.find((service) => service.sdk_href === id);
    setService(foundService || null);
  }, [id]);

  if (!service) {
    return (
      <div className="flex justify-center w-full p-4 md:p-6">
        <Loader />
      </div>
    );
  }

  return (
    <div className="flex flex-col w-full overflow-hidden border divide-y divide-gorgonzola-blue-50 rounded-xl border-gorgonzola-blue-50">
      <div className="flex flex-col items-start justify-between w-full gap-2 sm:flex-row-reverse sm:items-center">
        <div className="w-full px-4 pt-4 sm:p-0 sm:w-fit sm:mr-6 sm:ml-auto">
          <BetaBadge className="justify-center w-full text-base sm:w-fit" />
        </div>
        <Breadcrumb />
      </div>
      <div className="flex flex-col items-center gap-4 p-4 xxl:gap-16 md:gap-6 lg:gap-8 xl:gap-12 md:p-6">
        <GarmentMeasurementServiceStepIndicator />
        <div className="flex justify-center w-full">
          {currentStep === 0 ? <ImageUpload /> : null} {currentStep === 1 ? <Processing /> : null} {currentStep === 2 ? <MeasurementResult /> : null}
        </div>
      </div>
      <GarmentMeasurementTourModal isOpen={showTourGuideModal} onClose={closeTourGuideModal} videoUrl="/assets/videos/garment-measurement-guide.webm" />
    </div>
  );
};

export default GarmentMeasurementService;
